import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, NavigationStart, NavigationCancel, NavigationError, ActivatedRoute } from '@angular/router';
import { SessionService, StoreService, ViewService } from '@ciptech/commons';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
	lb: any = {
		percent: 0
	};

	constructor(
		private router: Router,
		private cdRef: ChangeDetectorRef,
		private titleService: Title,
		private activatedRoute: ActivatedRoute,
		private store: StoreService,
		private session: SessionService,
		private view: ViewService
	) {
		let defaultTitle = this.titleService.getTitle();

		this.router.events.subscribe((event: any) => {
			// console.log('router change', event);
			// loading change routes
			switch (true) {
				case event instanceof NavigationStart:
					// this.loading = true;
					this.lb.percent = Math.random() * 30 + 30;
					this.lb.interval = setInterval(() => {
						this.lb.percent = Math.random() * ((100 - this.lb.percent) / 2) + this.lb.percent;
					}, 500);
					break;

				case event instanceof NavigationEnd:
					this.session.updateActivity();
					// Title page
					const rt = this.getChild(this.activatedRoute);
					rt.data.subscribe(data => {
						this.titleService.setTitle(data.title ? `CIPTECH: ${data.title}` : defaultTitle);
					});

				// break;

				case event instanceof NavigationEnd:
				case event instanceof NavigationCancel:
				case event instanceof NavigationError:
					// this.loading = false;
					clearInterval(this.lb.interval);
					setTimeout(() => {
						this.lb.percent = 100;
						setTimeout(() => this.lb.percent = 0, 500);
					}, 300);

					break;
			}

			// Por si ingresa a una pagina y en el init lo direcciona a otra como en Payment
			this.cdRef.detectChanges();
		});
		this.session.initializeActivityListeners();
		this.session.restoreSessionWatcher();
		this.view.RefreshViewByTrigger(this.session.userLogged$, 'authRefresh');
	}

	ngOnInit() {
		const ie = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
		ie && this.router.navigateByUrl('/browser');

		this.session.logout$
			.subscribe(() => {
				this.store.cartClear();
			});
	}

	getChild(activatedRoute: ActivatedRoute): ActivatedRoute {
		if (activatedRoute.firstChild) {
			return this.getChild(activatedRoute.firstChild);
		} else {
			return activatedRoute;
		}
	}

}
